import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  AdGroupTitle: {
    marginTop: '16px',
    '& .title': {
      fontWeight: 600,
    },
    '& .subtitle': {
      marginBottom: '16px',
    },
    '& .title, .subtitle': {
      fontSize: '20px',
    },
    '& .description': {
    },
  },
});

export const Title = ({ permissions }) => {
  const i18n = useContext(I18nContext);
  const IsRenameHotelToLodgingEnabled = permissions && permissions.dynamic && permissions.dynamic.IsRenameHotelToLodgingEnabled;
  const classes = useDefaultStyles(getStyles);
  return (
    <div className={classnames('adgroup-title', classes.AdGroupTitle)}>
      <div className="title">
        {IsRenameHotelToLodgingEnabled ? i18n.getString(_TL_('Create a property ad group')) : i18n.getString(_TL_('Create a hotel ad group'))}
      </div>
    </div>);
};
Title.propTypes = {
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      IsRenameHotelToLodgingEnabled: PropTypes.bool,
    }),
  }),
};

Title.defaultProps = {
  permissions: {
    dynamic: {
      IsRenameHotelToLodgingEnabled: false,
    },
  },
};
